import { Badge } from "@/components/ui/badge";
import { cn } from "@/utils/cn";
import { useTranslation } from "react-i18next";
import type { MCPDisplayStatus } from "../status";

const STATUS_CLASS: Record<MCPDisplayStatus, string> = {
  disabled: "bg-secondary text-secondary-foreground",
  needsAttention:
    "bg-[var(--warning-100)] text-[var(--warning-300)]",
  online: "bg-[var(--success-100)] text-[var(--success-300)]",
  offline:
    "bg-[var(--destructive-100)] text-[var(--destructive-300)]",
  testing: "bg-[var(--warning-100)] text-[var(--warning-300)]",
};

type Props = {
  status: MCPDisplayStatus;
  title?: string;
  className?: string;
};

const MCPStatusBadge = ({ status, title, className }: Props) => {
  const { t } = useTranslation();

  return (
    <Badge
      data-status={status}
      title={title}
      className={cn(
        "min-h-6 justify-center border-0 px-2 py-[3px]",
        STATUS_CLASS[status],
        className,
      )}
    >
      {t(`mcpPage.status.${status}`)}
    </Badge>
  );
};

export default MCPStatusBadge;
